import './OxylinkLogo.scss';

import classNames from 'classnames';
import React from 'react';

import {
	Logo,
	LogoProps,
	LogoFactory,
} from '../../../../libs/IdeLink.Web.Common/src/components/Logo';
import { NAVBAR_C_LOCATION } from '../../../../libs/IdeLink.Web.Common/src/components/NavBar';
import { AUTH_BASE_C_LOCATION } from '../../../../libs/IdeLink.Web.Common/src/modules/Auth/Pages/components/AuthBase/AuthBase';
import { AsyncPageLoading } from '../../../../libs/IdeLink.Web.Common/src/scenes/AsyncPageLoading';
import { Loading } from '../../../../libs/IdeLink.Web.Common/src/scenes/Loading';

import OxylinkLogoLogin from '../../assets/images/logo-login.png';
import OxylinkLogoNavbar from '../../assets/images/logo-navbar.png';
import OxylinkLogo from '../../assets/images/logo.png';

export const overrideOxylinkLogo = () => {
	//* nav
	LogoFactory.register(`**/${NAVBAR_C_LOCATION}`, ({ className = '', ...props }: LogoProps) => (
		<div className={classNames({ 'OxylinkLogo-navbar-container': true })}>
			<Logo
				{...props}
				className={classNames('OxylinkLogo-navbar', { [className]: className })}
				src={OxylinkLogoNavbar}
			/>
		</div>
	));

	//* auth pages
	LogoFactory.register(
		`**/${AUTH_BASE_C_LOCATION}`,
		({ className = '', ...props }: LogoProps) => (
			<div
				className={classNames('OxylinkLogo-auth-page-container', {
					[className]: className,
				})}
			>
				<Logo {...props} src={OxylinkLogoLogin} />
			</div>
		)
	);

	//* loading pages
	LogoFactory.register(
		[`**/${AsyncPageLoading.C_LOCATION}/`, `**/${Loading.C_LOCATION}`],
		(props) => <Logo {...props} src={OxylinkLogo} />
	);

	//* rest
	LogoFactory.register('**', (props) => <Logo {...props} src={OxylinkLogo} />);
};
